module.exports = __webpack_public_path__ + "static/right-37d3cbf877ce3753bfa4b808315307ea.jpg";